var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.project)?_c('tab-slide-configuration',{attrs:{"project":_vm.project}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }